import { createListenerMiddleware } from '@reduxjs/toolkit';
import { windowScrollTo } from 'utils';
import { setAlert } from '../features/checkout/slice';

export const rootListener = createListenerMiddleware();
export default rootListener;

rootListener.startListening({
  actionCreator: setAlert,
  effect: async () => {
    windowScrollTo({ left: 0, top: 0, behavior: 'smooth' });
  },
});
